<section *removeIfUnauthorized="hasNESSAdmin">
  <div class="alert alert-info d-flex flex-column justify-content-evenly" role="alert">
    <p><small><i aria-hidden="true" class="fas fa-info-circle fa-1x me-2"></i> To <strong>download</strong> the latest version of the event or user import, from the Import Templates table, click on the desired filename link and follow the prompts.</small></p>
    <p class="mb-0"><small><i aria-hidden="true" class="fas fa-info-circle fa-1x me-2"></i> To <strong>upload</strong> the latest version of the event or user import template, from the Upload New Import Template section, click the import type dropdown and choose the desired template. Locate your file and then click Upload.  The uploaded template will appear in the Import Templates table.</small></p>
  </div>
  <h2 class="h4">Import Templates</h2>
  <p-table #dt [columns]="cols" [value]="attachmentsGrid" [autoLayout]="true" responsiveLayout="scroll">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" scope="col">
          <span class="text-nowrap">{{col.header}}</span>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of columns">
          <td [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'AttachmentTypes'">{{rowData[col.field].AttachmentDisplayName}}</ng-container>
            <ng-container *ngSwitchCase="'FileName'">
              <button class="btn btn-link p-0" (click)="onClickDownload(rowData)"><i aria-hidden="true" class="fas fa-file-download"></i> {{rowData[col.field]}}</button>
              <a aria-hidden="true" class="d-none" [download]="rowData[col.field]" #downloadTemplateLink></a>
            </ng-container>
            <ng-container *ngSwitchCase="'CreatedOn'">{{rowData[col.field] | utcToLocal:'MM/dd/yyyy'}}</ng-container>
            <ng-container *ngSwitchDefault>{{rowData[col.field]}}</ng-container>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          No documents found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
<section>
  <h2 class="h4" id="ttUploadLabel">Upload New Import Template</h2>
  <div>
    <select aria-labelledby="ttUploadLabel" class="form-select" [(ngModel)]="selectedAttachmentType">
      <option value="">Select a template type</option>
      <ng-container *ngIf="attachmentTypes$ | async as attachments">
        <option *ngFor="let attachment of attachments" value="{{attachment.AttachmentTypeName}}">{{attachment.AttachmentDisplayName}}</option>
      </ng-container>
    </select>
    <p-messages key="tempUploadMsgs" [closable]="true"></p-messages>
    <ng-container *ngIf="selectedAttachmentType">
      <div class="notes my-3">
        Notes:
        <ol>
          <li><i>Max size allowed per file: 5MB</i></li>
          <li><i>File types supported: XLS, XLSX</i></li>
        </ol>
      </div>
      <p-fileUpload id="InformationReportAttachmentUpload" #fileInput [url]="uploadUrl" name="attachments[]" accept=".xls,.XLS,.xlsx,.XLSX" [maxFileSize]="maxFileSize" invalidFileSizeMessageSummary="{0}: Invalid file size." invalidFileSizeMessageDetail="Maximum upload size is {0}. File was NOT uploaded." (onSelect)="buildUploadURL();" (onUpload)="onUploadHandler($event)" (onError)="onUploadError($event)">
      </p-fileUpload>
    </ng-container>
  </div>
</section>
